/*
 * @Author: wangshengqiang
 * @Date: 2021-07-07 11:14:55
 * @LastEditTime: 2022-03-01 11:04:13
 * @LastEditors: wangshengqiang
 * @Description:
 */
import React, { useContext } from 'react';
export const FormContext = /*#__PURE__*/React.createContext();
export const useFormContext = () => {
  return useContext(FormContext);
};